export const EducationList = [
    {
      institution: 'Binus University',
      degree: 'Bachelor of Computer Science (Current GPA: 3.43)',
      duration: '2022 - Present'
    }
  ];